import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css/bundle';

export default function initSwipers() {

    /**
     * Single image swiper
     */
    const singleSwiper = new Swiper(".single-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        modules: [Navigation, Pagination, A11y],
        navigation: {
          nextEl: ".single-slider-next",
          prevEl: ".single-slider-prev",
        },
        pagination: {
          el: ".single-slider-pagination",
          type: "bullets",
          clickable: true,
        }
    });

    /**
     * Gallery image swiper
     */
    const gallerySwiper = new Swiper(".gallery-slider", {
      slidesPerView: 'auto',
      spaceBetween: 8,
      modules: [Navigation, Pagination, A11y],
      navigation: {
        nextEl: ".gallery-slider-next",
        prevEl: ".gallery-slider-prev",
      },
      pagination: {
        el: ".gallery-slider-pagination",
        type: "bullets",
        clickable: true,
      }
    });
}